module.exports = __webpack_public_path__ + "img/oufu_66x89x10_5b.prt.4779fc57.jpg";